declare global {
    interface Window {
        rmxo_homeUrl: string;
        rmxo_indexPage: string;
        rmxo_pageTitle: string;
        rmxo_pathPrefix: string;
    }
}

export enum FilterTypes {
    flats = 4,
    houses = 6,
    lands = 3,
    commercials = 99,
    others = 97,
}

export enum OfferType {
    all,
    sell,
    rent,
}

export type TypedComponentProps = {
    type: FilterTypes;
};

export type Pagination = {
    count: number;
    page: number;
    nextPage: number;
    prevPage?: number;
};

export interface ResultContent {
    url: string;
    headline?: string;
    upperContent?: string;
    lowerContent?: string;
}

export * from "Types/offers";
export * from "Types/filters";
export * from "Types/map";
